import { Component, effect, inject, model, input } from '@angular/core';
import {
  FormGroup,
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import { CrudService } from '../../core/services/crud.service';
import { CategoryForm } from '../../core/services/crud.interface';
import { ModalComponent } from '../../shared/components/modal/modal.component';
import { removeEmptyValues } from '../../shared/helpers';

@Component({
  selector: 'app-category-form',
  imports: [ReactiveFormsModule, ModalComponent],
  templateUrl: './category-form.component.html',
  styles: ``,
})
export class CategoryFormComponent {
  private crudService = inject(CrudService);

  showModal = model(false);
  existingCategory = input();

  categoryForm = new FormGroup({
    name: new FormControl('', Validators.required),
    description: new FormControl(''),
  });

  confirmationMessage = '';
  errorMessage = '';

  buttonText = '';

  constructor() {
    effect(() => {
      if (this.showModal()) {
        if (this.existingCategory() !== null) {
          this.categoryForm.patchValue({
            name: (this.existingCategory() as any)['name'],
            description: (this.existingCategory() as any)['description'],
          });
          this.buttonText = 'Actualizar';
        } else {
          this.clearForm();
          this.buttonText = 'Crear';
        }
      }
    });
  }

  submit() {
    const cleanCategoryForm = removeEmptyValues(this.categoryForm.value);

    this.confirmationMessage = '';
    this.errorMessage = '';

    if (this.existingCategory() !== null) {
      // this.updateCategory(cleanCategoryForm as CategoryForm);
      this.updateCategory(this.categoryForm.value as CategoryForm);
    } else {
      this.createCategory(cleanCategoryForm as CategoryForm);
    }
  }

  createCategory(cleanCategoryForm: CategoryForm) {
    this.crudService.createCategory(cleanCategoryForm).subscribe({
      next: (response: any) => {
        if (response.status === 201) {
          this.confirmationMessage = 'Categoría añadida';
          this.clearForm();
        }
      },
      error: (error: any) => {
        if (error.status === 409) {
          this.errorMessage = error.error.message;
        } else {
          this.errorMessage = 'Error inesperado. Intente nuevamente.';
        }
        this.clearForm();
      },
    });
  }

  updateCategory(categoryForm: CategoryForm) {
    this.crudService
      .updateCategory((this.existingCategory() as any)['id'], categoryForm)
      .subscribe({
        next: (response: any) => {
          if (response.ok) {
            this.close();
          }
        },
      });
  }

  cancel() {
    this.close();
  }

  close() {
    this.showModal.set(false);
  }

  clearForm() {
    this.categoryForm.reset({
      name: '',
      description: '',
    });
  }
}
